import { useRef, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/layout/Container';
import { Section } from '@/components/layout/Section';
import { Eyebrow } from '@/components/domain/Eyebrow';
import { useFadeUpOnScroll } from '@/hooks/useFadeUpOnScroll';
import styles from './BoundarySection.module.css';

export const BoundarySection: FC = () => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useFadeUpOnScroll(ref, { selector: '[data-fade]', stagger: 0.06 });

  const items = t('home.boundaryStatement.items', { returnObjects: true }) as Array<{
    text: string;
  }>;

  return (
    <Section tone="muted" id="boundary">
      <Container size="default">
        <div ref={ref}>
          <header className={styles.header}>
            <div data-fade>
              <Eyebrow>{t('home.boundaryStatement.eyebrow')}</Eyebrow>
            </div>
            <h2 className={styles.title} data-fade>
              {t('home.boundaryStatement.title')}
            </h2>
          </header>

          <ul className={styles.list}>
            {items.map((item, idx) => (
              <li key={idx} className={styles.item} data-fade>
                <span className={styles.mark} aria-hidden="true">
                  ×
                </span>
                <span className={styles.text}>{item.text}</span>
              </li>
            ))}
          </ul>

          <p className={styles.quote} data-fade>
            {t('home.boundaryStatement.quote')}
          </p>
        </div>
      </Container>
    </Section>
  );
};

BoundarySection.displayName = 'BoundarySection';
